<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<v-row>
			<v-col cols="12" style="padding:0 40px 40px">
				<v-row>
					<v-col cols="12" md="4">
						<div>
							<div>تاریخ شروع</div>
							<date-picker ref="startDate" v-model="data.startDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" auto-submit disabled />
						</div>
					</v-col>
					<v-col cols="12" md="4">
						<div>
							<div>تاریخ پایان</div>
							<date-picker ref="endDate" v-model="data.endDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" auto-submit disabled />
						</div>
					</v-col>
					<v-col cols="12" md="4" class="d-flex flex-align-end flex-justify-end">
						<export-excel :items="items" :headers="headers" :fileName="excelFileName">
						</export-excel>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="12">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :headers="headers" :items="items" :items-per-page="500" :search="search" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td>
										<div @click="manageLoans(row.item)" style="cursor:pointer">
											<div>{{ row.item.fullName }}</div>
											<div>{{ row.item.mobile }}</div>
										</div>
									</td>
									<td>
										<div @click="manageLoans(row.item)" style="cursor:pointer">
											<div class="">کد: {{row.item.code}}</div>
											<div class="grey--text text-small">{{ row.item.title }}</div>
										</div>
									</td>
									<td class="text-center">
										{{ row.item.amount.toString().toPriceFormat() }}
									</td>
									<td class="text-center">
										{{ row.item.month }}
									</td>
									<td class="text-center">
										{{ row.item.startDate }}
									</td>
									<td class="text-center">
										{{ row.item.isCheckouted ? 'بلی' : 'خیر' }}
										<div class="grey--text" v-if="row.item.isCheckouted">{{ row.item.checkoutDate }}</div>
									</td>
									<td class="text-center">
										{{ row.item.paid.toString().toPriceFormat() }}
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" :data="{member:selectedMember}" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'SponsoredLoans',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'manage-loan': ManageLoan,
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogLoansManager: false,
				selectedMember: {},
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'fullName',
						width: '150'
					}, {
						text: 'موبایل',
						align: ' d-none',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'وام',
						align: 'center',
						sortable: true,
						value: 'code',
						width: '100'
					}, {
						text: 'وام',
						align: ' d-none',
						sortable: true,
						value: 'title',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = `${value.amount}\n`
							text += (value.month * value.installment).toString()
							return text
						}
					}, {
						text: 'تعداد اقساط',
						align: 'center',
						sortable: true,
						value: 'month',
					}, {
						text: 'تاریخ شروع',
						align: 'center',
						sortable: true,
						value: 'startDate',
					}, {
						text: 'تسویه',
						align: 'center',
						sortable: true,
						value: 'isCheckouted',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.isCheckouted ? 'بلی' : 'خیر'
							if (value.isCheckouted)
								text += '\n' + value.checkoutDate
							return text
						}
					}, {
						text: 'پرداخت شده',
						align: 'center',
						sortable: true,
						value: 'paid',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.paid
							if (value.paidCount > 0)
								text += `\n ${value.paidCount} قسط`
							return text
						}
					}
				],
				items: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست وام های اسپانسری ' + this.data.title
				if (this.startDate)
					name += ' از ' + this.startDate.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
		},
		mounted() {
		},
		methods: {
			manageLoans(item) {
				this.selectedMember = { id: item.memberId, fullName: item.fullName, nationalCode: item.nationalCode, mobile: item.mobile }
				this.dialogLoansManager = true
				this.$nextTick(() => {
					this.$refs.manageLoan.loadData()
				})
			},
			loadData() {
				this.loading = true
				api.get('admin/report/SponsoredUserLoans/?start=' + `${this.data.startDate}&end=${this.data.endDate}&loanId=${this.data.id}`, {})
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style>
</style>
